var map = {
	"./avatar-percy-base-full.png": 29556,
	"./avatar-percy-dino-full.png": 7433,
	"./avatar-percy-fall-full.png": 29848,
	"./avatar-percy-smoothie-full.png": 49333,
	"./avatar-percy-space-full.png": 11723,
	"./avatar-percy-spring-full.png": 47748,
	"./avatar-percy-summer-full.png": 4684,
	"./avatar-percy-winter-full.png": 4432
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24081;